import React, { Component } from 'react'
import ContactTab from '../../components/Tabs/ContactTab'

export default class Quality extends Component {
    render() {
        return (
            <div className="quality-wrapper">
                <div className="container">
                    <ContactTab title="الجوده" />
                </div>  
            </div>
        )
    }
}
